import { debounce as _debounce } from 'lodash';

import { fetchComputedInventoryForModification } from './index';

export default _debounce(fetchComputedInventoryForModification, 300);
